import React from 'react';

import {
  DisclaimerModal,
  ModalDisclaimer,
  ModalDisclaimersService,
} from '@vw-marketing/us-components';

import { AppConfigurationContext } from './hooks/use-app-configuration';
import { Disclaimer, FeatureAppConfig } from './typing/main';
import { FeatureAppStandalone } from './app/standalone';
import { getDisclaimerKeys } from './utils/general';
import { useDisclaimerReference } from './hooks/use-disclaimer-reference';
import { useFeatureAppContent } from './hooks/use-feature-app-content';
import ModalDisclaimerWrapper from './components/modal-disclaimer-wrapper';

export const App: React.FC<{}> = () => {
  const disclaimerService = useDisclaimerReference;
  const { disclaimers } = useFeatureAppContent();

  const appConfiguration: FeatureAppConfig = {
    disclaimers: getDisclaimerKeys(
      (disclaimers as Disclaimer[]) || [],
      disclaimerService,
    ),
  };

  const initialDisclaimerData: ModalDisclaimer = {
    active: false,
  };

  return (
    <AppConfigurationContext.Provider value={appConfiguration}>
      <ModalDisclaimersService disclaimerData={initialDisclaimerData}>
        <FeatureAppStandalone />
        <ModalDisclaimerWrapper>
          <DisclaimerModal
            disclaimers={appConfiguration.disclaimers as Disclaimer[]}
          />
        </ModalDisclaimerWrapper>
      </ModalDisclaimersService>
    </AppConfigurationContext.Provider>
  );
};
